export default {
    tempConnections: {},
    uid: '电梯云平台',
    baseURL:"192.168.16.206",
    newWebRtcHost:"https://www.haohaoaiziji.cn",
    failMessageMap:{
        ad_videos0: "广告视频1更新失败",
        ad_videos1: "广告视频2更新失败",
        ad_videos2: "广告视频3更新失败",
        apk:"终端系统升级失败",
        elevator_voices:'乘梯音效更新失败',
        license_images0:'电梯使用标志图片1更新失败',
        license_images1:'电梯使用标志图片2更新失败',
        license_images2:'电梯使用标志图片3更新失败',
        scroll_para:'字幕更新失败',
        floor_voice:'音频音量更新失败',
        system_voice:'系统音量更新失败',
        video_voice:'视频音量更新失败',
        brightness_para:'终端屏幕亮度更新失败',
        close_voice:'关门声音更新失败',
        open_voice:'开门声音更新失败',
        weather:'天气更新失败',
        liftStatelife:300
    },
    baseJSON:{
        "ad_videos":[
            {"cycle_times":"1","end_time":"","file_size":"","index":0,"name":"","url":""},
            {"cycle_times":"1","end_time":"","file_size":"","index":1,"name":"","url":""},
            {"cycle_times":"1","end_time":"","file_size":"","index":2,"name":"","url":""}],
        "apk":{"file_size":"","url":"","version":"1"},
        "elevator_voices":[{"file_size":"","name":"","url":""}],
        "license_images":[
            {"end_time":"","file_size":"","index":0,"name":"","url":""},
            {"end_time":"","file_size":"","index":1,"name":"","url":""},
            {"end_time":"","file_size":"","index":2,"name":"","url":""}],
        "scroll_para":
            {"content_list":[
                {"content":"","end_time":""},
                    {"content":"","end_time":""},
                    {"content":"","end_time":""}],
                "speed":"2"},
        "system_para":{
            "advert_para":{"auto_start":true,"para1":"1","para2":"8"},
            "brightness_para":10,"chatRoom_para":{"action":"create_room","content":"msg from : mobile1 1554856311225","fromDevice":"lift1","is_video":1,"life_time":-1,"record_slice":60000,"room_id":"lift1","server_signal":"wss://www.diantiyun.com:3000","server_stun":"stun:www.diantiyun.com","server_turn_tcp":"turn:www.diantiyun.com?transport=tcp","server_turn_tcp_password":"55633d357661e032fd954a74858d44b3","server_turn_tcp_username":"sylg","server_turn_udp":"turn:www.diantiyun.com?transport=udp","server_turn_udp_password":"55633d357661e032fd954a74858d44b3","server_turn_udp_username":"sylg","toDevice":"mobile1","wait_time":100000},"door_para":{"close_voice":true,"open_voice":true},"mqtt_para":"lift1","ui_para":"style1","voice_para":{"floor_voice":34,"system_voice":20,"video_voice":34}},"weather":{"name":"","temp":"","windDir":"","windLevel":""}},
    webrtc: {
        roomType: null,
        roomTypeOptions: {
            MONITOR: 'monitor',
            FILE: 'file',
            HELP: 'help'
        }
    }
}